/* eslint-disable ember/no-classic-components */
import Component from "@ember/component";

export default class ConnectorContainer extends Component {}
